import get from 'lodash/get';
import { takeLatest, put, call, all, fork } from 'redux-saga/effects';
import TokenProvider, {
    setValue,
} from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { getPLCCBanner } from 'yoda-interfaces/lib/Account/AccountApi';
import * as ActionTypes from '../actionTypes/PLCCBannerActionTypes';
import FSaga from './FactorySaga';
import { DP_JCP_CARD } from '../common/Constants';

function getJCPCardLocalStore() {
    return TokenProvider.get(DP_JCP_CARD) || {};
}
function* storeJCPCardInfo(cardInfo = {}) {
    // clears the previous value and reset
    setValue(DP_JCP_CARD, cardInfo);
    yield;
}

export function* getPLCCBannerSaga(action) {
    try {
        // 1. Check localStorage for caching previous
        // Stored Data
        const JCPCardLocalStore = getJCPCardLocalStore();
        const isValidStorage = JCPCardLocalStore.cardType;
        if (isValidStorage && !action.requestFrom) {
            const response = JCPCardLocalStore;
            yield all([put({ type: ActionTypes.PLCC_BANNER_SUCCESS, response })]);
            return;
        }
        // 2. If cached response is not present
        // lets call api
        action = { ...action, payload: { customHeaders: { DP_USER_HAS_JCP_CARD: true } } };
        const response = yield call(FSaga, getPLCCBanner, action, undefined, false);
        if (response.isSuccess) {
            const responseData = get(response, 'response.data', {});
            yield all([
                put({ type: ActionTypes.PLCC_BANNER_SUCCESS, response: responseData }),
                fork(storeJCPCardInfo, responseData),
            ]);
        } else {
            const plccBannerError = {
                errorCode: 'PLCCBANNER_API_RESPONSE_ERROR',
                errorMessage: 'PLCCBanner API response Error',
            };
            yield put({
                type: ActionTypes.PLCC_BANNER_ERROR,
                error: plccBannerError,
            });
        }
    } catch (error) {
        const plccError = {
            errorCode: 'PLCCBANNER_ERROR',
            errorMessage: 'PLCCBanner Expectional Error',
        };
        yield put({
            type: ActionTypes.PLCC_BANNER_ERROR,
            error: plccError,
        });
    }
}

const watchPLCCBannerSaga = function* watchPLCCBannerSaga() {
    yield takeLatest(ActionTypes.PLCC_BANNER_REQUEST, getPLCCBannerSaga);
};
watchPLCCBannerSaga.sagaName = 'watchPLCCBannerSaga';

export default watchPLCCBannerSaga;
